export default __webpack_public_path__ + "static/pattern-logo-bb7ec69d13cf3e5f88d9108b943c6e0d.svg";